module.exports = __webpack_public_path__ + "static/media/FIND MY ISRCS LOGO updated darker.jpg-1.a674ccd8.png";